import React from "react";

const VARIANTS = {
    success: {
        cls: "bg-[#7cc93c]/10 text-[#7cc93c] border-[#7cc93c]/25",
        dot: "#7cc93c",
    },
    failed: {
        cls: "bg-[#ff453a]/10 text-[#ff453a] border-[#ff453a]/25",
        dot: "#ff453a",
    },
    pending: {
        cls: "bg-[#ff9f0a]/10 text-[#ff9f0a] border-[#ff9f0a]/25",
        dot: "#ff9f0a",
    },
    needs_review: {
        cls: "bg-[#ff9f0a]/10 text-[#ff9f0a] border-[#ff9f0a]/25",
        dot: "#ff9f0a",
    },
    running: {
        cls: "bg-[#0a84ff]/10 text-[#0a84ff] border-[#0a84ff]/25",
        dot: "#0a84ff",
    },
    resolved: {
        cls: "bg-[#9ca3af]/10 text-[#9ca3af] border-[#9ca3af]/25",
        dot: "#9ca3af",
    },
    dismissed: {
        cls: "bg-[#9ca3af]/10 text-[#9ca3af] border-[#9ca3af]/25",
        dot: "#9ca3af",
    },
};

const LABELS = {
    success: "SUCCESS",
    failed: "FAILED",
    pending: "PENDING",
    needs_review: "NEEDS REVIEW",
    running: "RUNNING",
    resolved: "RESOLVED",
    dismissed: "DISMISSED",
};

export default function StatusPill({ status }) {
    const v = VARIANTS[status] || VARIANTS.pending;
    const pulse = status === "running";
    return (
        <span
            data-testid={`status-pill-${status}`}
            className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-[2px] text-[10px] font-mono uppercase tracking-[0.15em] border ${v.cls}`}
        >
            <span
                className={`inline-block w-1.5 h-1.5 rounded-full ${pulse ? "pc-dot-pulse" : ""}`}
                style={{ background: v.dot }}
            />
            {LABELS[status] || status?.toUpperCase() || "UNKNOWN"}
        </span>
    );
}
